module.exports = __webpack_public_path__ + "static/media/handButtonIcon.7cccbaf6.svg";